/**
 * Rounds a given number to a specified number of decimal places.
 *
 * @param {number} value - The number to be rounded.
 * @param {number} [decimals=2] - The number of decimal places to round to. Defaults to 2 if not specified.
 * @returns {number} The number rounded to the specified number of decimal places.
 * @example roundToDecimals(12.3456) => 12.35
 */
export const roundToDecimals = (value: number, decimals: number = 2) => {
    if (!value) return 0;

    const isExponentialNotation = value.toString().includes('e');

    if (isExponentialNotation) {
        return Number(value.toFixed(decimals));
    }

    return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
};

export const formatNumber = (value: number | string, locale: string = 'et-EE') => {
    return Intl.NumberFormat(locale).format(Number(value));
};

/**
 * Round to the nearest
 * @param value - number to round
 * @param digitsFromLeft - digits from left to round to - default 2
 * @returns rounded number
 * @example roundToNearest(123456) => 130000
 * @example roundToNearest(123456, 4) => 123500
 * @example roundToNearest(123456, 5) => 123460
 */
export const roundToNearest = (value: number, digitsFromLeft = 2) => {
    const num = Math.abs(roundToDecimals(value, 0));

    const divider = Math.pow(
        10,
        num.toString().length > digitsFromLeft
            ? num.toString().length - digitsFromLeft
            : 1,
    );

    const roundedNum = Math.ceil((num + 1) / divider) * divider;

    return value < 0 ? -roundedNum : roundedNum;
};
